import * as actionTypes from "./actions";
import config from "./../config";

const initialState = {
    ...config
};

export const setAuth = val => ({ type: actionTypes.AUTH_INFO, payload: val });

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.AUTH_INFO:
            state = { auth: action.payload };
            return {
                ...state,
                auth: action.payload
            };
        default:
            return state;
    }
};

export default reducer;
